import { useEffect } from "react";

/**
 * Phase 8 — lightweight per-page SEO. Sets <title>, meta description and
 * the noindex header for protected/customer/admin areas. No extra deps.
 */
export default function SEO({ title, description, noindex = false, canonicalPath }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const setMeta = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
        return el;
      }
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      return el;
    };

    let descMeta = null;
    let ogTitleMeta = null;
    let ogDescMeta = null;
    let robotsMeta = null;
    let canonicalLink = null;

    if (description) {
      descMeta = setMeta('meta[name="description"]', { name: "description", content: description });
      ogTitleMeta = setMeta('meta[property="og:title"]', { property: "og:title", content: title || "WelkomBiz Photography" });
      ogDescMeta = setMeta('meta[property="og:description"]', { property: "og:description", content: description });
    }
    if (noindex) {
      robotsMeta = setMeta('meta[name="robots"]', { name: "robots", content: "noindex, nofollow" });
    } else {
      robotsMeta = setMeta('meta[name="robots"]', { name: "robots", content: "index, follow" });
    }
    if (canonicalPath) {
      canonicalLink = document.head.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement("link");
        canonicalLink.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute("href", `${window.location.origin}${canonicalPath}`);
    }

    return () => {
      document.title = prevTitle;
    };
  }, [title, description, noindex, canonicalPath]);

  return null;
}
